import axios from "axios";
const KEY="sp_support22";
const API=process.env.REACT_APP_API_BASE_URL.replace(/\/$/,"");
let context=null;
const store={
 getItem:key=>sessionStorage.getItem("sp_view_"+key),
 setItem:(key,value)=>sessionStorage.setItem("sp_view_"+key,String(value)),
 removeItem:key=>sessionStorage.removeItem("sp_view_"+key),
 clear:()=>Object.keys(sessionStorage).filter(key=>key.startsWith("sp_view_")).forEach(key=>sessionStorage.removeItem(key)),
};
export function supportContext(){return context;}
export function supportRequest(action,data){return axios.post(API+"?status=1&f="+encodeURIComponent(action),data,{headers:{"X-SP-Support":context.token},timeout:20000});}
export async function endSupport(returnToProfile=true){
 const previous=context;
 try{if(previous)await supportRequest("supportEnd");}catch(_){}
 sessionStorage.removeItem(KEY);store.clear();
 if(returnToProfile&&previous)window.location.replace("https://www.backend.salsaworldstandardclass.com/de/student-info/"+previous.student_id);
}
export function seedSupportProfile(profile){
 if(!profile||profile.status!==true||String(profile.user_id)!==String(context.student_id)||profile.user_type!=="student"||!profile.session_fields)throw new Error("Das Schülerprofil konnte nicht eindeutig geladen werden.");
 Object.entries(profile.session_fields).forEach(([key,value])=>{if(value!==null&&value!==undefined)store.setItem(key,value);});
 store.setItem("session_language",store.getItem("session_language")||"de");
 // Non-secret compatibility marker for native URL builders; removed before every API request.
 store.setItem("session_user_login_cookie","support-session");
}
export async function bootSupport(){
 const entry=window.location.pathname==="/support";
 const saved=sessionStorage.getItem(KEY);
 if(!entry&&!saved)return false;
 const grant=entry?new URLSearchParams(window.location.hash.slice(1)).get("grant"):null;
 if(grant){
  window.history.replaceState(null,"","/support");
  if(!/^[a-f0-9]{64}$/.test(grant))throw new Error("Ungültiger Schülerzugang.");
  const form=new FormData();form.append("grant",grant);
  const reply=await axios.post(API+"?status=1&f=supportRedeem",form,{timeout:20000});
  if(reply.data?.status!==true)throw new Error("Schülerzugang nicht verfügbar.");
  context=reply.data;
 }else context=JSON.parse(saved);
 if(context?.scope!=="student_app"||context.read_only!==false||!/^[a-f0-9]{64}$/.test(context.token||"")||Date.now()>=context.expires_at*1000)throw new Error("Bitte den Schülerzugang erneut über das Profil öffnen.");
 Object.defineProperty(window,"localStorage",{configurable:true,get:()=>store});
 if(grant)store.clear();
 seedSupportProfile(context.profile);
 sessionStorage.setItem(KEY,JSON.stringify(context));
 axios.interceptors.request.use(config=>{
  const url=new URL(config.url,window.location.origin);
  const base=new URL(API);
  // Other normal App services keep their own authentication; never leak our support token there.
  if(url.origin!==base.origin||!url.pathname.startsWith(base.pathname))return config;
  url.searchParams.delete("login_cookie");
  if(!url.searchParams.has("status"))url.searchParams.set("status","1");
  if(config.data instanceof FormData)config.data.delete("login_cookie");
  config.url=url.toString();config.headers["X-SP-Support"]=context.token;return config;
 });
 axios.interceptors.response.use(response=>{
  const url=response.config?.url?new URL(response.config.url,window.location.origin):null;const base=new URL(API);
  if(url?.origin===base.origin&&url.pathname.startsWith(base.pathname)&&url.searchParams.get("f")==="getlogininfo"&&response.data?.status===true)seedSupportProfile(response.data);
  return response;
 },error=>{
  if(error.response&&[401,403].includes(error.response.status)&&error.response.data?.code==="support_expired")window.dispatchEvent(new Event("sp-support-expired"));
  return Promise.reject(error);
 });
 if(entry)window.history.replaceState(null,"",Number(context.profile.is_pause_student)===1?"/Home/course/pauseCourse":"/Home/dashboard");
 return true;
}
